export default "__VITE_ASSET__C7IWXl55__"